import { UserCreditBalance } from './UserCreditBalance';
import { CreditPurchasePanel } from './CreditPurchasePanel';
import { UserSubscriptionPanel } from './UserSubscriptionPanel';
import { PaymentHistory } from './PaymentHistory';
import { StripeConnectSetup } from './StripeConnectSetup';
import { PayoutHistory } from './PayoutHistory';
import { useUserRole } from '@/hooks/useUserRole';
import ErrorBoundary from '@/components/ErrorBoundary';

export const CreditsAndBillingTab = () => {
  const { role, loading } = useUserRole();

  const isPractitioner = role === 'practitioner';

  return (
    <div className="space-y-6">
      {/* Credit Balance Overview */}
      <ErrorBoundary>
        <UserCreditBalance showTransactions={false} />
      </ErrorBoundary>

      {/* Practitioner-specific sections */}
      {!loading && isPractitioner && (
        <>
          {/* Stripe Connect Account Setup */}
          <ErrorBoundary>
            <StripeConnectSetup />
          </ErrorBoundary>

          {/* Payout History */}
          <ErrorBoundary>
            <PayoutHistory />
          </ErrorBoundary>
        </>
      )}

      {/* Purchase Credits */}
      <ErrorBoundary>
        <CreditPurchasePanel />
      </ErrorBoundary>

      {/* Subscription Management */}
      <ErrorBoundary>
        <UserSubscriptionPanel />
      </ErrorBoundary>

      {/* Payment History */}
      <ErrorBoundary>
        <PaymentHistory />
      </ErrorBoundary>
    </div>
  );
};
